var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronMenu = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 8,
  height: 13,
  viewBox: "0 0 8 13",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#348CFD",
  strokeWidth: 1.25,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m1.5 1.5 5 5M1.5 11.5l5-5"
}))));
export { SvgChevronMenu as ReactComponent };
export default __webpack_public_path__ + "assets/images/chevron-menu.svg";